<template>
  <div class="product_list_wrap">
    <div
      v-for="productGroup in productsByGroup"
      :key="productGroup.name"
      class="daily_item"
    >
      <p>{{ productGroup.name }}</p>
      <ul class="smallImg_list">
        <template v-for="product in productGroup.items">
          <products-item-info-detail
            v-if="product.count > 0"
            :key="product.item_sku"
            :product="product"
          />
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import ProductsItemInfoDetail from './ProductsItemInfoDetail.vue';

export default {
  name: 'ProductsDetail',
  components: {
    ProductsItemInfoDetail,
  },
  props: {
    productsByGroup: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style>

</style>
